module.exports = __webpack_public_path__ + "img/dz.bd8f73fa.jpg";